/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParcelInboundPicVo
 */
export interface ParcelInboundPicVo {
    /**
     * 图片URL
     * @type {string}
     * @memberof ParcelInboundPicVo
     */
    imageUrl?: string;
    /**
     * 操作人姓名
     * @type {string}
     * @memberof ParcelInboundPicVo
     */
    operatorName?: string;
    /**
     * 实地考察日期
     * @type {string}
     * @memberof ParcelInboundPicVo
     */
    createTime?: string;
    /**
     * 确认日期
     * @type {string}
     * @memberof ParcelInboundPicVo
     */
    confirmTime?: string;
    /**
     * 操作人ID
     * @type {number}
     * @memberof ParcelInboundPicVo
     */
    staffId?: number;
}

/**
 * Check if a given object implements the ParcelInboundPicVo interface.
 */
export function instanceOfParcelInboundPicVo(value: object): value is ParcelInboundPicVo {
    return true;
}

export function ParcelInboundPicVoFromJSON(json: any): ParcelInboundPicVo {
    return ParcelInboundPicVoFromJSONTyped(json, false);
}

export function ParcelInboundPicVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParcelInboundPicVo {
    if (json == null) {
        return json;
    }
    return {
        
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'operatorName': json['operatorName'] == null ? undefined : json['operatorName'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'confirmTime': json['confirmTime'] == null ? undefined : json['confirmTime'],
        'staffId': json['staffId'] == null ? undefined : json['staffId'],
    };
}

export function ParcelInboundPicVoToJSON(json: any): ParcelInboundPicVo {
    return ParcelInboundPicVoToJSONTyped(json, false);
}

export function ParcelInboundPicVoToJSONTyped(value?: ParcelInboundPicVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'imageUrl': value['imageUrl'],
        'operatorName': value['operatorName'],
        'createTime': value['createTime'],
        'confirmTime': value['confirmTime'],
        'staffId': value['staffId'],
    };
}

